import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SheetOlimpica } from '../../../../types/models/manufacturing/mallaOlimpica.model.type';

interface SheetOlimpicaState {
  isFetching: boolean;
  data: SheetOlimpica[];
  total: number;
  error: string | undefined;
  selectedItem?: SheetOlimpica;
  filters: {
    materialCode: string;
    pageNumber: number;
    pageSize: number;
  };
}

const initialState: SheetOlimpicaState = {
  isFetching: false,
  data: [],
  total: 0,
  error: undefined,
  selectedItem: undefined,
  filters: {
    materialCode: '',
    pageNumber: 1,
    pageSize: 50,
  },
};

const sheetOlimpicaSlice = createSlice({
  name: 'sheetOlimpica',
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.isFetching = true;
      state.error = undefined;
    },
    rxSuccessFetching: (
      state,
      { payload }: PayloadAction<{ list: SheetOlimpica[]; total: number }>,
    ) => {
      state.isFetching = false;
      state.data = payload.list;
      state.total = payload.total;
    },
    rxErrorFetching: (
      state,
      { payload }: PayloadAction<string | undefined>,
    ) => {
      state.isFetching = false;
      state.error = payload;
      state.data = [];
    },
    // Al setear filtros, siempre regresamos a la página 1
    rxSetFilters: (state, { payload }: PayloadAction<any>) => {
      state.filters = { ...state.filters, ...payload, pageNumber: 1 };
    },
    rxSetSelectedItem: (
      state,
      { payload }: PayloadAction<SheetOlimpica | undefined>,
    ) => {
      state.selectedItem = payload;
    },
    rxResetSelectedItem: (state) => {
      state.selectedItem = undefined;
    },
    rxSetPageNumber: (state, { payload }: PayloadAction<number>) => {
      state.filters.pageNumber = payload;
    },
    rxSetPageSize: (state, { payload }: PayloadAction<number>) => {
      state.filters.pageSize = payload;
      state.filters.pageNumber = 1;
    },
  },
});

export const {
  rxStartFetching,
  rxSuccessFetching,
  rxErrorFetching,
  rxSetFilters,
  rxSetSelectedItem,
  rxResetSelectedItem,
  rxSetPageNumber,
  rxSetPageSize,
} = sheetOlimpicaSlice.actions;

export default sheetOlimpicaSlice.reducer;
